import { useEffect, useState } from 'react'
import './App.css'
import { chatBotWhite } from './assets/icons';
import Chatbot from './components/Chatbot';
import { ToastContainer } from 'react-toastify';
import { AppConfig, InteractionMode } from '../types';
import LoginScreen from './components/LoginScreen';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from './routes/PrivateRoutes';
import Baselayout from './layout/Baselayout';
import PublicRoute from './routes/PublicRoutes';
import Login from './pages/login';
import Signup from './pages/signup';

function App() {
  const [isShowButton, setIsShowButton] = useState<boolean>(false);
  const [test, setTest] = useState<string>("");
  const [errored, setError] = useState<boolean>(false);
  const [followUP, setFollowUP] = useState<boolean>(false);
  const [typePassword, setTypePassword] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [config, setConfig] = useState<AppConfig>({ mode: 'hybrid', username: '' });

  return (

    <>
      <ToastContainer
        autoClose={1500}
        closeOnClick={true}
        pauseOnFocusLoss
        pauseOnHover
        position="bottom-right"
      />
      <Routes>
        <Route element={<PrivateRoute />}>
          <Route path="*" element={<Baselayout />} />
        </Route>

        <Route element={<PublicRoute />}>
          <Route path="/login" element={<LoginScreen />} />
          {/* <Route path="/signup" element={<Signup />} /> */}
          {/* <Route path="/reset-password" element={<ResetPassword />} /> */}
        </Route>
      </Routes>
    </>
  )
}

export default App;
